import { loadStripe } from "@stripe/stripe-js";

import useStripe from "@Composables/useStripe";

export default {
  state: {
    loadingStripe: false,
    stripe: null,
  },

  getters: {
    loadingStripe: (state) => state.loadingStripe,
    stripe: (state) => state.stripe,
  },

  actions: {
    initializeStripe({ state, dispatch }) {
      const { stripeKey } = useStripe();

      if (state.stripe) return Promise.resolve();
      if (state.loadingStripe) return dispatch("waitForStripe");

      state.loadingStripe = true;

      return loadStripe(stripeKey)
        .then((stripe) => (state.stripe = stripe))
        .finally(() => (state.loadingStripe = false));
    },

    waitForStripe({ getters }) {
      return new Promise((resolve, reject) => {
        if (!getters.loadingStripe) {
          return resolve();
        }

        const interval = setInterval(() => {
          if (!getters.loadingStripe) {
            resolve();
            clearInterval(interval);
          }
        }, 10);
      });
    },

    waitForSparkState({ getters }) {
      return new Promise((resolve, reject) => {
        if (getters.isSparkStateLoaded) {
          return resolve();
        }

        const interval = setInterval(() => {
          if (getters.isSparkStateLoaded) {
            resolve();
            clearInterval(interval);
          }
        }, 10);
      });
    },
  },
};
